export const EVENT_APP_ORG_ID_KEY = 'event_app_org_id';
export const PREVIOUS_AUTH_SYSTEM_KEY = 'event_app_previous_auth_system';
